import api from "api/axios";
import {EvaluationEmployee, EvaluationItem, EvaluationOverview, EvaluationPayload} from "../modal/evaluate_context"

export async function fetchEvaluationEmployees(): Promise<{
  scope: string;
  employees: EvaluationEmployee[];
}> {
  const res = await api.get("/admin/evaluation/employees");
  return res.data || { scope: "self", employees: [] };
}

export async function fetchEmployeeEvaluations(empId: number): Promise<{
  employee?: EvaluationEmployee;
  evaluations: EvaluationItem[];
}> {
  const response = await api.get(`/admin/evaluation/evaluate/${empId}`);
  return response.data || { evaluations: [] };
}

export async function postEmployeeEvaluation(empId: number, evaluationData: EvaluationPayload): Promise<void> {
  await api.post(`/admin/evaluation/evaluate/${empId}`, evaluationData);
}

export async function updateEmployeeEvaluation(
  empId: number,
  evaluationId: number,
  evaluationData: Partial<EvaluationPayload>
): Promise<void> {
  await api.patch(`/admin/evaluation/update-evaluation/${empId}?evaluation_id=${evaluationId}`, evaluationData);
}

export async function deleteEmployeeEvaluation(empId: number, evaluationId: number): Promise<void> {
  await api.delete(`/admin/evaluation/delete-evaluation/${empId}?evaluation_id=${evaluationId}`);
}

export async function fetchEvaluationOverview(week?: string): Promise<EvaluationOverview> {
  const res = await api.get("/admin/evaluation/overview", { params: week ? { week } : undefined });
  return res.data;
}
